import React from 'react';
import s from './s.module.less';

/**
 * 琥珀色警示条。原型 .amber-callout —— 同一个组件在两处使用：
 * Patient limits 页的暂停横幅（#pausedBanner）和 Performance 页的黄条（#perfLimitCallout），
 * 这样 provider 落在哪个 chip 上看到的都是同一套观感。
 *
 * 图标是原型 warnIcon() 的内联 SVG（20px 琥珀实心圆 + 白色感叹号），
 * 不用 antd 的图标：那套是线性描边，和设计稿的实心盘不是一个东西。
 */
interface Props {
    children: React.ReactNode;
    /** 右侧的行动链接，例如「Raise the number →」。不传则不渲染 */
    action?: { label: string; onClick: () => void };
}

const WarnIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" className={s.calloutIcon}>
        <circle cx="10" cy="10" r="8.5" fill="#FBBF24" />
        <path d="M10 6v4.5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
        <circle cx="10" cy="13.5" r="1" fill="#fff" />
    </svg>
);

const AmberCallout: React.FC<Props> = ({ children, action }) => (
    <div className={s.callout}>
        <div className={s.calloutRow}>
            <WarnIcon />
            <p className={s.calloutText}>{children}</p>
            {action && (
                <button type="button" className={s.calloutLink} onClick={action.onClick}>
                    {action.label}
                </button>
            )}
        </div>
    </div>
);

export default AmberCallout;
